module.exports = __webpack_public_path__ + "static/media/instant_win_default_banner.b8668c29.png";